import { Box, Button } from "@blasterjs/core";
import { debounce } from "lodash";
import React, { useState } from "react";
import styled from "styled-components";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(faWandMagicSparkles);

interface Props {
  readonly onChange: (annotationOpacity: number) => void;
  readonly onReset: () => void;
}

const AnnotationOpacityControls = styled(Box)`
  margin-top: auto;
  position: relative;
  background: #fff;
  padding: 0.2rem 1.2rem 0.2rem 0.2rem;
  display: flex;
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0),
    0 1px 1px rgba(16, 22, 26, 0.2);
  height: 3.6rem;
  margin-left: 3px;
  margin-right: 3px;
  position: relative;
`;

const ResetButton = styled(Button)`
  position: relative;
  padding-top: 0;
  padding-bottom: 0;
  font-size: ${props => props.theme.fontSizes[1]};
`;

const AnnotationOpacity = ({ onChange, onReset }: Props) => {
  const [sliderValue, setValue] = useState(100);
  const debouncedOnChange = debounce(onChange, 100);
  const onSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue: number = parseInt(e.target.value, 0);
    setValue(newValue);
    debouncedOnChange(newValue);
  };
  const onResetButtonClick = () => {
    setValue(100);
    onReset();
  };
  return (
    <AnnotationOpacityControls>
      <ResetButton
        title="Reset annotation opacity"
        pl={1}
        pr={1}
        appearance="minimal"
        onClick={onResetButtonClick}
      >
        <FontAwesomeIcon icon={faWandMagicSparkles} color="#3d3e40" />
      </ResetButton>
      <input
        title="AI Annotation Opacity"
        type="range"
        min={0}
        max={100}
        step={1}
        onChange={onSliderChange}
        value={sliderValue}
        style={{
          color: "green",
          position: "relative",
          width: "10rem",
          cursor: "grab"
        }}
      />
    </AnnotationOpacityControls>
  );
};

export default AnnotationOpacity;
